document.addEventListener('DOMContentLoaded', () => {
  const formContainers = document.querySelectorAll('.product-consultation_form');
  formContainers.forEach((container) => {
    const section = container.closest('[data-section]');
    const sectionId = section.dataset.section;
    const productForm = document.querySelector(`#product-form-${sectionId}`);
    const addToCartButton = productForm.querySelector('.product-form__submit');
    const priceContainer = document.querySelector(`#price-${sectionId}`);
    const form = container.querySelector('.product-consultation_form__healthcare');
    const toggle = container.querySelector('.product-consultation_form__toggle');
    const inputs = form.querySelectorAll('input:not([type="hidden"]), select, textarea');
    const productForMyselfYes = form.querySelector('[name="properties[ProductForMyself]"][value="Yes"]');
    const termsCheckbox = form.querySelector('[name="properties[TermsAccepted]"]');
    const hasHidePrice = priceContainer && priceContainer.classList.contains('hidden-price');

    // Toggle form visibility
    if (toggle) {
      toggle.addEventListener('click', () => {
        container.classList.toggle('expanded');
      });
    }

    // Validate form
    const validateForm = () => {
      let isValid = true;
      inputs.forEach((input) => {
        if (input.hasAttribute('required') && !input.value.trim()) {
          isValid = false;
        }
      });
      if (!termsCheckbox.checked) {
        isValid = false;
      }
      if (!productForMyselfYes.checked) {
        isValid = false;
      }
      return isValid;
    };

    // Update button and price visibility
    const updateButtonAndPrice = () => {
      const isValid = validateForm();
      if (addToCartButton) {
        addToCartButton.disabled = !isValid;
      }
      if (hasHidePrice && priceContainer) {
        priceContainer.style.display = isValid ? 'block' : 'none';
      }
    };

    // Prevent form submission if invalid
    if (productForm) {
      productForm.addEventListener('submit', (e) => {
        if (!validateForm()) {
          e.preventDefault();
          alert('Please complete all required fields in the healthcare form.');
        }
      });
    }

    // Add event listeners to inputs
    inputs.forEach((input) => {
      input.addEventListener('input', updateButtonAndPrice);
      input.addEventListener('change', updateButtonAndPrice);
    });

    // Initial validation
    updateButtonAndPrice();
  });
});